import React, {useState} from 'react';
import PropTypes from 'prop-types';
import TextareaAutosize from "react-textarea-autosize";
import {omit} from "lodash";

const TextareaAutoHeight = props => {
  const [value, setValue] = useState(props.value)

  const onBlur = () => {
    props.onChange(value);
    props.onBlur && props.onBlur();
  };

  return (
    <TextareaAutosize
      className={`form-control ${props.className}`}
      onChange={e => setValue(e.target.value)}
      onBlur={onBlur}
      value={value || ''}
      {...omit(props, ['className', 'onChange', 'onBlur', 'value'])}
    />

  );
};

TextareaAutoHeight.defaultProps = {
  value: '',
  className: '',
  minRows: 3,
  maxRows: 10,
  autoFocus: false,
};

TextareaAutoHeight.propTypes = {
  autoFocus: PropTypes.bool,
  minRows: PropTypes.number,
  maxRows: PropTypes.number,
  className: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default TextareaAutoHeight;